import {AccessorsMutatorsDecorator} from "../../helpers";
import {TranslatableModel} from "./translatable-model";

export class MabeetPaymentGatewayApiSettings extends TranslatableModel {}

AccessorsMutatorsDecorator(
    'profile_id',
    'api_key'
)(MabeetPaymentGatewayApiSettings);


// WEBPACK FOOTER //
// ./src/pms-api/models/mabeet-payment-gateway-api-settings.model.js